import '@arco-design/web-react/dist/css/arco.css';

import { useState, useEffect } from 'react';
import { Table, Space, Button } from '@arco-design/web-react';

function DataTable({ rowData, columnData, total, loading, onChangeTable, current, pageSize }) {
    // ""
    const [pagination, setPagination] = useState({
        sizeCanChange: true,
        showTotal: true,
        total: 0,
        pageSize: 10,
        current: 1,

        pageSizeChangeResetCurrent: true,
    });
    // const [loading, setLoading] = useState(loading);

    useEffect(() => {
        setPagination(prev => ({ ...prev, total: total, current: current, pageSize: pageSize }))
    }, [total, current, pageSize])
    // //console.log({ pageSize })



    return (
        <div className='arco_table1'>

            <Table


                loading={loading}
                columns={columnData}
                data={rowData}
                pagination={onChangeTable ? pagination : false}
                onChange={onChangeTable}
                borderCell
                // rowSelection={{
                //     selectedRowKeys: selectedRows,
                //     onChange: (selectedRowKeys) => setSelectedRows(selectedRowKeys),
                //   }}
                renderPagination={(paginationNode) => (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'end',
                            marginTop: 10,
                        }}
                    >

                        {paginationNode}

                    </div>
                )}
            />
        </div>
    );
}

export default DataTable;
